package com.schoolconnect.app.feature.examresults

import com.schoolconnect.app.feature.attendance.ParentAttendanceChild
import com.schoolconnect.app.feature.common.PaginationPolicy

data class ParentExamResultRowUi(val id: String, val exam: String, val date: String, val marks: String, val percentage: String, val overall: String, val remarks: String, val detail: String)
data class ParentExamResultsSummaryUi(val totalExams: String = "—", val overallAverage: String = "—", val bestSubject: String = "—", val needsImprovementSubject: String = "—")
data class ParentExamSubjectResultUi(val subject: String, val grade: String, val rank: String, val marks: String, val totalMarks: String, val percentage: String)
data class ParentExamResultDetailUi(val studentName: String, val className: String, val rollNumber: String, val exam: String, val startDate: String, val totalMarks: String, val outOf: String, val percentage: String, val grade: String, val rank: String, val subjects: List<ParentExamSubjectResultUi> = emptyList(), val remarks: String = "")

enum class ParentExamResultSortField(val apiValue: String) {
    EXAM("exam_name"),
    START_DATE("start_date"),
    TOTAL_MARKS("total_obtained"),
    PERCENTAGE("percentage"),
    OVERALL_RESULT("grade"),
    REMARKS("remarks")
}

data class ParentExamResultsState(
    val children: List<ParentAttendanceChild> = emptyList(),
    val selectedChildIndex: Int = 0,
    val rows: List<ParentExamResultRowUi> = emptyList(),
    val totalCount: Int = 0,
    val summary: ParentExamResultsSummaryUi = ParentExamResultsSummaryUi(),
    val search: String = "",
    val pageIndex: Int = 0,
    val pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
    val sortField: ParentExamResultSortField = ParentExamResultSortField.START_DATE,
    val sortAscending: Boolean = false,
    val viewing: ParentExamResultRowUi? = null,
    val viewingDetail: ParentExamResultDetailUi? = null,
    val isLoading: Boolean = true,
    val isViewingLoading: Boolean = false,
    val errorMessage: String = "",
    val viewingError: String = ""
) { val selectedChild: ParentAttendanceChild? get() = children.getOrNull(selectedChildIndex) }

sealed interface ParentExamResultsEvent {
    data class ChildSelected(val index: Int) : ParentExamResultsEvent
    data class SearchChanged(val value: String) : ParentExamResultsEvent
    data class PageChanged(val index: Int) : ParentExamResultsEvent
    data class PageSizeChanged(val size: Int) : ParentExamResultsEvent
    data class SortChanged(val field: ParentExamResultSortField) : ParentExamResultsEvent
    data class ViewRequested(val row: ParentExamResultRowUi) : ParentExamResultsEvent
    data object ViewDismissed : ParentExamResultsEvent
    data object Retry : ParentExamResultsEvent
}
